"use client";

import Link from "next/link";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigationItems = [
    { name: "Home", href: "/" },
    { name: "Programm", href: "/programm" },
    { name: "Teilnahme", href: "/anmeldung" },
    { name: "Kontakt", href: "/kontakt" },
  ];

  return (
    <header
      className="sticky left-0 right-0 top-0 z-50 border-b border-gothia-gold/20 bg-gothia-green backdrop-blur-md"
      style={{
        paddingTop: "env(safe-area-inset-top)",
      }}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <div>
            <Link href="/" className="text-section-title text-white">
              <div className="flex flex-col items-start md:hidden">
                <div className="text-caption normal-case text-white">
                  150 Jahre
                </div>
                <div className="text-caption normal-case text-white/80">
                  AV Gothia
                </div>
              </div>
              <div className="hidden text-subheading text-white md:block">
                150. Stiftungsfest – AV Gothia
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden space-x-8 md:flex">
            {navigationItems.map((item) => (
              <div key={item.name}>
                <Link
                  href={item.href}
                  className="text-body font-medium text-gray-100 transition-colors duration-200 hover:text-gray-50">
                  {item.name}
                </Link>
              </div>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 text-white"
              aria-label="Toggle menu">
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation - Outside container to avoid padding */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden border-t border-gothia-gold/30 bg-gothia-green backdrop-blur-md md:hidden">
            <nav className="space-y-2 pb-4 pt-6">
              {navigationItems.map((item) => (
                <Link
                  key={item.name}
                  href={item.href}
                  className="block px-6 py-4 text-center text-body font-medium text-gray-100 transition-all duration-300 hover:bg-gothia-gold/10 hover:text-gray-50"
                  onClick={() => setIsMenuOpen(false)}>
                  {item.name}
                </Link>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
